export default __webpack_public_path__ + "images/705ff25dfae0231534bf46a72cb69d0c-pride_desktop.webp";